export const getMemberAvatar = (memberAvatarText, defaultMemberAvatar) => {
    let memberAvatarObject = {
        original: defaultMemberAvatar,
        100: defaultMemberAvatar,
        300: defaultMemberAvatar
    }
    if (!memberAvatarText) {
        return memberAvatarObject;
    }
    try {
        const protocol = new URL(memberAvatarText).protocol
        if (protocol === 'http:' || protocol === 'https:') {
            return {
                original: memberAvatarText,
                100: memberAvatarText,
                300: memberAvatarText
            }
        }
    } catch (err) { }

    try {
        memberAvatarObject = JSON.parse(memberAvatarText)
    } catch (err) { }
    if (!memberAvatarObject['original']) {
        memberAvatarObject['original'] = defaultMemberAvatar
    }
    if (!memberAvatarObject['100']) {
        memberAvatarObject['100'] = defaultMemberAvatar
    }
    if (!memberAvatarObject['300']) {
        memberAvatarObject['300'] = defaultMemberAvatar
    }
    return memberAvatarObject
};



/*
* 文字
TXT("txt"),

* 文字
WORD("docx", "doc", "dot", "wps", "wpt", "dotx", "docm", "dotm"),

* 表格
EXCEL("xlsx", "xls", "xlt", "et", "xltx", "csv", "xlsm", "xltm", "ett"),

* 演示文稿
PPT("pptx", "ppt", "pptm", "ppsx", "ppsm", "pps", "potx", "potm", "dpt", "dps", "pot"),

* PDF
PDF("pdf", "ofd"),

* 图片
PIC("bmp", "gif", "jpg", "pic", "png", "jpeg", "heic"),

* 压缩包
ZIP("rar", "zip", "gz", "7z"),

* 音频 
AUDIO("mp3", "mkv"),

* 视频 
VIDEO("wav", "aif", "au", "mp4", "rmvb", "avi", "3gp", "mov"),

* 其他类型
OTHER(),

* 其他类型，空
EMPTY();
*/

export const fileImgName = (type) => {
    if (type === 'TXT' || type === 'txt') {
        return 'cloud-txt';
    } else if (type === 'WORD' || type === 'docx' || type === 'doc' || type === 'dot' || type === 'wps' || type === 'wpt' || type === 'dotx' || type === 'docm' || type === 'dotm' || type === 'rtf') {
        return 'cloud-doc';
    } else if (type === 'EXCEL' || type === 'xlsx' || type === 'xls' || type === 'xlt' || type === 'et' || type === 'xltx' || type === 'csv' || type === 'xlsm' || type === 'xltm' || type === 'ett') {
        return 'cloud-xls';
    } else if (type === 'PPT' || type === 'pptx' || type === 'ppt' || type === 'pptm' || type === 'ppsx' || type === 'ppsm' || type === 'pps' || type === 'potx' || type === 'potm' || type === 'dpt' || type === 'dps' || type === 'pot') {
        return 'cloud-ppt';
    } else if (type === 'PDF' || type === 'pdf' || type === 'ofd') {
        return 'cloud-pdf';
    } else if (type === 'PIC' || type === 'ico' || type === 'bmp' || type === 'gif' || type === 'jpg' || type === 'pic' || type === 'png' || type === 'jpeg' || type === 'heic' || type === 'psd' || type === 'svg' || type === 'tiff' || type === 'tif') {
        return 'cloud-image';
    } else if (type === 'ZIP' || type === 'rar' || type === 'zip' || type === 'gz' || type === '7z' || type === 'tar' || type === 'jar' || type === 'gzip') {
        return 'cloud-zip';
    } else if (type === 'AUDIO' || type === 'mp3' || type === 'wma' || type === 'au' || type === 'aif') {
        return 'cloud-audio';
    } else if (type === 'VIDEO' || type === 'wav' || type === 'w4v' || type === 'w4a' || type === 'webm' || type === 'mkv' || type === 'mpg' || type === 'mpeg' || type === 'vob' || type === 'mts' || type === 'flv' || type === 'wmv' || type === 'aif' || type === 'au' || type === 'mp4' || type === 'rmvb' || type === 'rm' || type === 'avi' || type === '3gp' || type === 'mov') {
        return 'cloud-video';
    } else if (type === 'html' || type === 'htm') {
        return 'cloud-html';
    } else if (type === 'ipa') {
        return 'cloud-ipa';
    } else if (type === 'apk') {
        return 'cloud-apk';
    } else if (type === 'log' || type === 'ini' || type === 'inf' || type === 'cdr' || type === 'vsd' || type === 'vsdx') {
        return 'cloud-other-file';
    } else if (type === 'exe') {
        return 'cloud-exe'
    } else if (type === 'sketch') {
        return 'cloud-sketch';
    } else if (type === 'rp') {
        return 'cloud-rp';
    } else if (type === 'md') {
        return 'cloud-markdown';
    } else if (type === 'ttf' || type === 'eot' || type === 'otf' || type === 'fon' || type === 'font' || type === 'ttc' || type === 'woff') {
        return 'cloud-ttf';
    } else if (type === 'OTHER' || type === null || type === undefined) {
        return 'cloud-other';
    } else if (type === 'EMPTY' || type === 'FOLDER') {
        return 'cloud-folder';
    } else if (type === 'c' || type === 'cpp' || type === 'java' || type === 'js' || type === 'css' || type === 'lrc' || type === 'h' || type === 'asm' || type === 's' || type === 'asp' || type === 'bat' || type === 'bas' || type === 'prg' || type === 'cmd' || type === 'xml' || type === 'ts' || type === 'tsx') {
        return 'cloud-code';
    } else if (type === 'DOCUMENT') {
        return 'cloud-online-doc';
    }
    else {
        return 'cloud-other';
    }
}